import { useEffect, useState } from "react";
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { isImageValidPng, generatePDF, formatDate, getDateCombination } from '../../commonClass/CommonValidation';
import { useRef } from 'react';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomSelection from '../../../customControl/CustomSelection';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from "../../../customControl/CommonFilter";

const Bannermaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef = useRef();

    const [bannerdata, setBannerData] = useState([]);
    const [modalShow, setModalShow] = useState(false);

    const [bannerfilename, setBannerFileName] = useState();
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);
    const [filteritems, setFilterItems] = useState([]);
    const [bannerdelete, setbannerDelete] = useState('');

    const [bannerpath, setBannerPath] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const [bannerduplicateerrorMessage, setBannerDuplicateErrorMessage] = useState('');

    const [formValue, setFormValue] = useState(
        {
            BannerId: 0,
            BannerName: '',
            BannerFileName: '',
            BannerPath: '',
            IsActive: false,
            LocationId: 0,
            StateId: 0,
        }
    );

    const columns = [
        {
            name: 'Banner Name',
            key: 'bannerName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (banner) => banner.bannerName
        },
        {
            name: 'City',
            key: 'city',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (banner) => banner.city
        },
        {
            name: 'State',
            key: 'stateName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (banner) => banner.stateName
        },
        {
            name: 'Active',
            key: 'IsActiveFormat',
            sortable: true,
            float: "left",
            selector: (banner) => banner?.IsActiveFormat
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (banner) => new Date(banner.createdDate),
            format: (banner) => banner?.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (banner) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(banner.bannerId)}></i></button>
        },
        {
            name: 'View',
            selector: (banner) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-eye" onClick={() => handleViewMode(banner.bannerId)}></i> </button>
        }
    ];

    const LocationId = useRef()
    const [stateName, setStateName] = useState('')
    const [cityAllData, setCityAllData] = useState([])
    const [citydisable, setCityDisable] = useState(false);
    const [list, setList] = useState([])

    const getbannercity = async () => {
        const bannercity = await getAllData('/master/v1/getbannercity')
        setList(bannercity.data)
        setCityAllData(bannercity.data?.filter(IsAct => IsAct.isActive === true))
    }

    const cityData = cityAllData?.map(obj => ({
        label: obj?.city,
        value: obj?.locationId
    }))

    const handleCityData = (e) => {
        setFormErrors('');
        const state = list?.map(obj => {
            if (obj.locationId === e.value) {
                return { label: obj.stateName, value: obj.stateId }
            }
        }).find(x => x !== undefined)
        setStateName(state.label)
        setFormValue((form) => ({ ...form, LocationId: e.value, StateId: state.value }))
        setEditDisabled(true);
    }

    const getBannerDataList = async () => {
        const bannerlistdata = await getAllData("/master/v1/getallbanner");
        bannerlistdata?.data?.map((obj) => {
            obj.IsActiveFormat = obj?.isActive ? 'Active' : 'InActive';
            obj.CreatedDateFormat = formatDate(obj?.createdDate);
            return obj;
        })
        setBannerData(bannerlistdata.data);
        setFilterItems(bannerlistdata.data);
    }

    //#region handle getbannerdata
    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getBannerDataList().then(() => { dispatch(loaderActions.end()) });
            getbannercity();
        }
        else {
            ClearLocalStorage();;
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }, []);

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);
        });
    }, [user])
    //#endregion

    //#region image upload

    const [fileselected, setSelectedFile] = useState();

    const handleUploadImageLoad = (e) => {
        let error = {}
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files;
            const filename = getDateCombination(files?.[0]?.name);
            formValue.BannerFileName = filename
            formValue.BannerPath = 'CMS/Banner/' + filename
            setSelectedFile(e.target.files[0]);
            setEditDisabled(true);
            setBannerPath('');
            setBannerFileName('');
            setBannerDuplicateErrorMessage('');
        }
        else {
            document.getElementById("BannerPath").value = "";
            setFormValue({ ...formValue, BannerFileName: '', BannerPath: '' });
            setBannerPath('');
            error.BannerPath = "Only PNG file type is accepted.";
            setFormErrors(error);
            setBannerFileName('');
            setBannerDuplicateErrorMessage('');
            setIsSubmit(false);
            return;
        }
    }

    useEffect(() => {
        setFormErrors('');
    }, [fileselected]);

    const removeImage = () => {
        document.getElementById("BannerPath").value = "";
        formValue.BannerPath = ''
        formValue.BannerFileName = ''
        setBannerPath('');
        setSelectedFile();
        setEditDisabled(true);
        setBannerFileName('');
    };

    //#endregion

    //#region handle change and active value
    const onChange = (e) => {
        setBannerDuplicateErrorMessage('');
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
        setFormErrors('');
        setEditDisabled(true);
    }

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            setFormValue((form) => ({ ...form, IsActive: e }))
            setFormErrors('');
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormValue((form) => ({ ...form, IsActive: !formValue?.IsActive }))
            setFormErrors('');
            setEditDisabled(true);
        }
        setModalShow(false);
    }
    //#endregion

    //#region handle Add,Retrive, Edit, View
    const handleSubmitData = async () => {
        let statusoftoken = await verifytoken();
        if (buttonaddeditText === 'Add') {
            if (statusoftoken) {
                let status = false;
                const BannerData = await postUsersData('/master/v1/insertbanner', formValue)
                status = BannerData.status;
                if (status !== 400) {
                    try {
                        if (!BannerData.status && !BannerData.data) {
                            setBannerDuplicateErrorMessage(BannerData.message);
                            setDisabled(false);
                            setEditDisabled(true);
                            setIsSubmit(false);
                            return;
                        }
                        if (BannerData.status) {
                            if (BannerData.data > 0) {
                                await ImageUpload('CMS/Banner/', formValue.BannerFileName, fileselected);
                                dispatch({ type: 'ALERTING', message: BannerData.message })
                                clear();
                            }
                            else {
                                dispatch({ type: 'ALERTING', message: BannerData.message })
                                setIsSubmit(false);
                                return;
                            }
                        }
                    }
                    catch (err) {
                        dispatch({ type: 'ALERTING', message: err })
                        setDisabled(false);
                        setEditDisabled(true);
                        return;
                    }
                }
                else {
                    dispatch({ type: 'ALERTING', message: BannerData.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        else {
            if (statusoftoken) {
                let status1 = false;
                const BannerData = await patchUsersData('/master/v1/updatebanner', formValue)
                status1 = BannerData.status;
                if (status1 !== 400) {
                    try {
                        if (!BannerData.status && !BannerData.data) {
                            setBannerDuplicateErrorMessage(BannerData.message);
                            setDisabled(false);
                            setEditDisabled(true);
                            setIsSubmit(false);
                            return;
                        }
                        if (BannerData.status) {
                            if (bannerpath.length === 0) {
                                await ImageUpload('CMS/Banner/', formValue.BannerFileName, fileselected);
                            }
                            try {
                                if (bannerpath.length === 0) {
                                    await ImageDelete(bannerdelete);
                                }
                            }
                            catch (err) {
                                dispatch({ type: 'ALERTING', message: err })
                                setDisabled(false);
                                setEditDisabled(true);
                                setIsSubmit(false);
                                return;
                            }
                            dispatch({ type: 'ALERTING', message: BannerData.message })
                            clear();
                        }
                    }
                    catch (err) {
                        dispatch({ type: 'ALERTING', message: err })
                        setDisabled(false);
                        setEditDisabled(true);
                        setIsSubmit(false);
                        return;
                    }
                }
                else {
                    dispatch({ type: 'ALERTING', message: BannerData.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    setIsSubmit(false);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }

    }

    const onSubmitForm = e => {
        e.preventDefault();
        setFormErrors(validateData(formValue));
    };

    const validateData = (values) => {
        setIsSubmit(true);
        const error = {}
        if (values.LocationId === 0) {
            error.LocationId = "Kindly select the City Name";
            setIsSubmit(false);
        }
        if (!values.BannerName || values.BannerName?.trim()?.length === 0) {
            error.BannerName = "Please enter Banner Name";
            setIsSubmit(false);
        }
        if (values.BannerName?.length > 50) {
            error.BannerName = "Maximum length is 50 characters";
            setIsSubmit(false);
        }
        if (!values.BannerPath) {
            error.BannerPath = "Please select Banner Image";
            setIsSubmit(false);
        }
        return error;
    }

    useEffect(() => {
        if (Object.keys(formErrors)?.length === 0 && isSubmit) {
            setDisabled(true);
            setEditDisabled(false);
            handleSubmitData();
        }
        if (Object.keys(formErrors)?.length > 0) {
            let id = Object.keys(formErrors)[0];
            if (id === 'LocationId') {
                eval(id).current.focus();
            }

            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }
    }, [formErrors]);

    const handleEditMode = (id) => {
        setDisabled(false);
        setEditDisabled(false);
        setButtonAddEditText("Update");
        setSerachDisable(true);
        RetriveData(id);
    }

    const handleViewMode = (id) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisable(true);
        RetriveData(id);
    }

    const RetriveData = (id) => {
        document.getElementById("BannerPath").value = "";
        setSelectedFile('');
        setFormErrors('');
        setBannerDuplicateErrorMessage('');
        bannerdata?.map(obj => {
            if (obj.bannerId === id) {
                formValue.BannerName = obj.bannerName
                formValue.BannerPath = obj.bannerPath
                formValue.BannerId = obj.bannerId
                formValue.IsActive = obj.isActive
                formValue.BannerFileName = obj.bannerFileName
                formValue.StateId = obj.stateId
                formValue.LocationId = obj.locationId
                setBannerPath(CommonFileURLWithFolder + obj.bannerPath);
                setBannerFileName(obj.bannerFileName);
                setbannerDelete(obj.bannerPath);
                setStateName(obj.stateName)

                let allcitylist = list?.filter(IsAct => IsAct.isActive === true);

                setCityAllData(list?.filter(IsAct => IsAct.isActive === true));
                setCityDisable(false);
                if (obj.locationId !== 0) {
                    if (!allcitylist?.find(IsCity => IsCity.locationId === obj.locationId)) {
                        setCityDisable(true)
                        setCityAllData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, list?.find(isCity => isCity.locationId === obj.locationId)] : [])
                    }
                }
            }
        });
        setFormValue({ ...formValue, formValue })
    }

    //#endregion

    //#region handle clear value
    const clear = () => {
        setIsSubmit(false);
        setFormErrors('');
        setBannerFileName('');
        setFormValue({ ...formValue, BannerId: 0, BannerName: '', BannerFileName: '', BannerPath: '', IsActive: false, LocationId: 0, StateId: 0 });
        setStateName('')
        setSelectedFile();
        setSerachBy('All');
        setSearchValue('');
        setSerachDisable(false);
        setBannerDuplicateErrorMessage('');
        setDisabled(false);
        setEditDisabled(true);
        getBannerDataList();
        setbannerDelete('');
        setButtonAddEditText('Add');
        setBannerPath('');
        document.getElementById("BannerPath").value = "";
        setCityDisable(false)
    }
    //#endregion

    //#region handle pdf and excel import
    const PdfExport = () => {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = bannerdata?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "BannerMaster", "Banner Master");
    }

    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, bannerdata, "BannerMaster", "BannerMaster.xls");
    }
    //#endregion

    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>Banner Master</h3>
            </div>
            <div class="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div class="mb-3 row mx-1">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                                {bannerduplicateerrorMessage && <div className="text-danger pb-3 text-center"> {bannerduplicateerrorMessage} </div>}

                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12 mb-1">
                                            <label htmlFor="" className='col-form-label required'>Select City</label>
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12">
                                            {/* <Select
                                                ref={LocationId}
                                                className="dropdown select_dropdown"
                                                options={cityData}
                                                value={cityData?.filter(function (city) {
                                                    return city.value === cityId;
                                                })}
                                                onChange={(e) => { handleCityData(e) }}
                                                isDisabled={disabled ? true : false}
                                            /> */}
                                            <CustomSelection
                                                selId="LocationId"
                                                selRef={LocationId}
                                                datalist={cityData}
                                                fieldid={formValue?.LocationId}
                                                SelectionChange={handleCityData}
                                                isdisable={disabled}
                                                isactivedisable={citydisable}
                                                issearchable={true}
                                            />
                                            {formErrors.LocationId && <p className="text-start text-danger">{formErrors.LocationId} </p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12 mb-1">
                                            <label htmlFor="" className='col-form-label required'>State</label>
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12 mb-1">
                                            <input
                                                className='form-control'
                                                type="text"
                                                value={stateName}
                                                onChange={handleCityData}
                                                disabled />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div className='row'>
                                        <div class="col-lg-4 col-md-12 col-sm-12">
                                            <label for="inputPassword6" class="col-form-label required">Banner Name</label>
                                        </div>
                                        <div class=" col-lg-8 col-md-12 col-sm-12">
                                            <input type="text" id="BannerName" class="form-control"
                                                name="BannerName"
                                                value={formValue.BannerName}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder="Banner Name"
                                            />
                                            {formErrors.BannerName && <p className='text-danger text-start'>{formErrors.BannerName}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='row'>
                                        <div class="col-lg-4 col-md-12 mb-1">
                                            <label for="inputPassword6" class="col-form-label required">Upload Image</label>
                                        </div>
                                        <div class="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                            <div class="input-group">
                                                <input
                                                    ref={inputRef}
                                                    name='BannerImage'
                                                    type="file"
                                                    id="BannerPath"
                                                    onChange={handleUploadImageLoad}
                                                    class="form-control btn_add"
                                                    accept=".png"
                                                    disabled={disabled ? true : false}
                                                />
                                                <label class="input-group-text" for="BannerPath">Browse</label>
                                            </div>
                                            {formErrors.BannerPath && <p className='text-danger text-start'>{formErrors.BannerPath}</p>}
                                            {bannerfilename && <p className='text-start overflow-hidden' data-bs-toggle="tooltip" data-bs-placement="left" title={bannerfilename}>
                                                {bannerfilename}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='row'>
                                        <div class="col-lg-4 col-md-12 col-sm-12">
                                            <label for="inputPassword6" class="col-form-label">Active</label>
                                        </div>
                                        <div class="col-auto col-lg-8">
                                            <Switch
                                                onChange={handleisActive}
                                                checked={formValue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            {fileselected &&
                                (
                                    <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2">
                                        <img
                                            src={URL.createObjectURL(fileselected)} className="img-fluid w-100" alt=''
                                        />
                                        <button onClick={() => removeImage()} type="button" data-close style={{ objectposition: "right top;", position: "absolute", fontSize: "36px", background: 'none', border: 'none' }} disabled={disabled ? true : false} >&times;</button>
                                    </div>
                                )}
                            {(!fileselected && bannerpath?.trim()?.length > 0) && (
                                <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2" >
                                    <img
                                        src={bannerpath} className="img-fluid w-100" alt=''
                                    />
                                    <button onClick={() => removeImage()} type="button" data-close style={{ objectposition: "right top;", position: "absolute", fontSize: "36px", background: 'none', border: 'none' }} disabled={disabled ? true : false} >&times;</button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" class="btn btn-primary mx-1" id="btnClear" onClick={clear} >Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filteritems}
                        searchDisabled={serchdisable}
                        getdata={getBannerDataList}
                        setlistdata={setBannerData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={bannerdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />

                </form>
            </div>
        </>
    )
}

export default Bannermaster